/*
 * @LastEditors: 熊望
 */
import axios from 'axios';
import { changeUrlForIE } from '@/util/browser';
import {
    rewardApiBuryPoint, // 打赏
    praiseAndUninterestedApiBuryPoint, // 点赞
    attentionAndCollectApiBuryPoint, // 关注
} from './knowledge-operation-buried-point'; // 埋点

const PATH = '/knowledge-operation/';

// 纷享学习模块--------------------------------------------------------------------

/**
 * 主页右侧: 个人信息
 * @param {*} option
 */
export function personalInfoApi(option) {
    return axios.get(`${PATH}currency/person-currency-account`, { params: option });
}

/**
 * 主页右侧: 人气纷享号列表
 * @param {*} option
 */
export function shareAcountsApi(option) {
    return axios.get(`${PATH}come-enjoy/gethot`, { params: option });
}

/**
 * 主页右侧: 人气纷享号列表是否开启人气值展示
 * @param {*} option
 */
export function shareAcountsHotApi() {
    return axios.get('system/rule-config/key?key=KNOWLEDGE_OPERATION_CONFIG');
}

/**
 * tab页-推荐: 内容列表数据
 * @param {*} option
 */
export function recommendedListApi(option) {
    return axios.get(`${PATH}question/recommend-question`, { params: option });
}

/**
 * tab页-推荐: 个性化推荐
 * @param {*} option
 */
export function recommendPersonalApi(option) {
    return axios.get('/zxy-log/recommend/personal', { params: option || {} });
}

/**
 * tab页-推荐: 达观推荐内容列表
 * @param {*} option
 */
export function daGuanRecommendedListApi(option) {
    return axios.get(`${PATH}question/recommend`, { params: option });
}

/**
 * tab页-推荐: 纷享号推荐内容
 * @param {*} option
 */
export function recommendShareAcountsApi(option) {
    return axios.get(`${PATH}come-enjoy/recommend`, { params: option });
}

/**
 * tab页-推荐: 查询纷享号认证状态
 * @param {*} option
 */
export function shareCertificationStatusApi(option) {
    return axios.get(`${PATH}come-enjoy/getnotice`, { params: option });
}

/**
 * tab页-推荐: 清除纷享号认证状态
 * @param {*} option
 */
export function clearCertificationStatusApi(option) {
    return axios.get(`${PATH}come-enjoy/clearnotice`, { params: option });
}

/**
 * tab页-关注: 内容列表数据
 * @param {*} option
 */
export function attentionListApi(option) {
    return axios.get(`${PATH}attention/attention-question`, { params: option });
}

/**
 * tab页-热榜: 热门专栏列表
 * @param {*} option
 */
export function hotListColumnsApi(option) {
    return axios.get(`${PATH}special-column/column-recommend`, { params: option });
}

/**
 * tab页-热榜: 热门专栏下卡片的内容列表
 * @param {*} option
 */
export function hotColumnsCardApi(option) {
    return axios.get(`${PATH}special-column/column-contents/${option.id}`, { params: option });
}

/**
 * tab页-热榜: 热门话题列表
 * @param {*} option
 */
export function hotTopicApi(option) {
    return axios.get(`${PATH}topic/hot-topic`, { params: option });
}

/**
 * tab页-热榜: 内容列表
 * @param {*} option
 */
export function hotListApi(option) {
    return axios.get(`${PATH}question/hot-question`, { params: option });
}

/**
 * tab页-我的订阅: 专栏列表
 * @param {*} option
 */
export function subscriptionColumnsApi(option) {
    return axios.get(`${PATH}special-column/subscribe-column`, { params: option });
}

/**
 * tab页-我的订阅: 内容列表
 * @param {*} option
 */
export function subscriptionListApi(option) {
    return axios.get(`${PATH}/attention/subscribe-question`, { params: option });
}

/**
 * 话题详情页头部信息
 * @param {*} option
 */
export function topicHeadApi(option) {
    return axios.get(`${PATH}topic/topic-info`, { params: option });
}

/**
 * 话题详情页内容列表
 * @param {*} option
 */
export function topicListApi(option) {
    return axios.get(`${PATH}topic/topic-question`, { params: option });
}

/**
 * 我的关注/讨论/收藏-tab栏数据统计
 * @param {*} option
 */
export function tabsCountApi(option) {
    return axios.get(`${PATH}attention/my-statistic`, { params: option });
}

/**
 * 我的关注-tab栏数据统计
 * @param {*} option
 */
export function attentionTabsCountApi(option) {
    return axios.get(`${PATH}attention/my-attention-statistic`, { params: option });
}

/**
 * 我的关注-关注的纷享者列表
 * @param {*} option
 */
export function attentionSharerListApi(option) {
    return axios.get(`${PATH}come-enjoy/getattention`, { params: option });
}

/**
 * 我的关注-关注的话题列表
 * @param {*} option
 */
export function attentionTopicListApi(option) {
    return axios.get(`${PATH}topic/my-attention-topic`, { params: option });
}

/**
 * 我的讨论-讨论列表数据
 * @param {*} option
 */
export function talkListApi(option) {
    return axios.get(`${PATH}discuss/my-discuss-info`, { params: option });
}

/**
 * 我的收藏-内容列表数据
 * @param {*} option
 */
export function collectionListApi(option) {
    return axios.get(`${PATH}attention/collect-question`, { params: option });
}

// 纷享内容列表、详情里的相关操作---------------------------

/**
 * 根据id获取内容详情页数据
 * @param {*} option
 */
export function shareContentDetailApi(id) {
    return axios.get(`${PATH}question/question-info?id=${id}`);
}

/**
 * 保存用户浏览数
 */
export function shareContentBrowseCountApi(option) {
    return axios.post(`${PATH}read`, option, { encode: true });
}

/**
 * 获取内容详情页的相关推荐
 * @param {*} option
 */
export function shareContentRecommendListApi(id) {
    return axios.get(`${PATH}?id=${id}`);
}

/**
 * 用户订阅专栏
 * @param {*} option
 */
export function subscribeColumnsApi(option) {
    return axios.post(`${PATH}special-column/subscribe`, option, { encode: true });
}

/**
 * 获取打赏配置
 */
export function rewardConfigApi() {
    return axios.get('system/rule-config/key?key=CURRENCY_REWARD_RULE_CONFIG');
}

/**
 * 获取学币名称配置
 */
export function currencyConfigApi() {
    return axios.get('system/rule-config/key?key=CURRENCY_RULE_CONFIG');
}

/**
 * 获取纷享内容的打赏详情
 */
export function rewardDetailApi(option) {
    return axios.get(`${PATH}question/reward-member-list`, { params: option });
}

/**
 * 对纷享内容打赏
 * @param {*} option
 */
export function rewardApi(option) {
    rewardApiBuryPoint(option);
    return axios.post(`${PATH}currency/reward`, option, { encode: true });
}

/**
 * 关注/取消关注，收藏/取消收藏
 * @param {*} businessId 业务ID
 * @param {*} businessType 业务类型 0:内容 1:专栏 2:纷享号 3：话题
 */
export function attentionAndCollectApi(option) {
    attentionAndCollectApiBuryPoint(option);
    return axios.post(`${PATH}attention`, option, { encode: true });
}

/**
 * 点赞、不感兴趣操作
 * @param {*} businessId 业务ID
 * @param {*} actionType 行为类型0:点赞 1:不感兴趣
 * @param {*} businessType 业务类型0内容，1讨论，2讨论回复
 */
export function praiseAndUninterestedApi(option) {
    praiseAndUninterestedApiBuryPoint(option);
    return axios.post(`${PATH}action`, option, { encode: true });
}

/**
 * 查询是否已举报
 * @param {*} option
 */
export function reportStatusApi(option) {
    return axios.get(`${PATH}accuse/isAccuse`, { params: option });
}

/**
 * 举报纷享内容或评论
 * @param {*} option
 */
export function reportContentApi(option) {
    return axios.post(`${PATH}accuse`, option, { encode: true });
}

/**
 * 根据纷享内容id获取评论内容数据
 * @param {*} option
 */
export function commentListApi(option) {
    return axios.get(`${PATH}discuss`, { params: option });
}

/**
 * 对纷享内容进行评论或回复
 * @param {*} questionId 评论的内容ID
 * @param {*} discussType 类型：1：讨论，2：回复
 * @param {*} content 内容
 * @param {*} toMemberId 针对哪个用户进行评论或回复
 * @param discussId 回复的讨论ID
 */
export function replyCommentApi(option) {
    return axios.post(`${PATH}discuss`, option, { encode: true });
}

/**
 * 获取评论审核状态
 */
export function replyCommentStatusApi(option) {
    return axios.get(`${PATH}action/get-discuss-status`, { params: option });
}

/**
 * 删除评论
 */
export function deleteCommentApi(option) {
    return axios.delete(`${PATH}discuss`, { params: option });
}

/**
 * 评论区点赞
 * @param {*} option
 */
export function praiseApi(option) {
    return axios.post(`${PATH}system/comment/praise`, option, { encode: true });
}

/**
 * 获取pdfEncode
 * @param {*} option
 */
export function pdfEncodeApi(option) {
    return axios.get('human/file/down-encode-auth', { params: option });
}

/**
 * 获取视频附件地址
 * @param {*} option
 */
export function videoAttachmentApi(id) {
    return axios.get(changeUrlForIE(`course-study/file/safe-new/${id}`));
}

/**
 * 获取M3u8FileToken
 * @param {*} option
 */
export function m3u8FileTokenApi(option) {
    return axios.get('course-study/file/m3u8-token', { params: option });
}

// --------------------------------------------------------------------------

/**
 * 获取可点击次数
 * @param {*} option
 */
export function maxClickTimesApi(option) {
    return axios.get(`${PATH}material/count-materials-by-title-length`, { params: option });
}
/**
 * 获取换一换的智能封面
 * @param {*} option
 */
export function backgrondCoversApi(option) {
    return axios.get(`${PATH}material/cycle`, { params: option });
}

/**
 * 获取查询素材列表的筛选条件
 * @param {*} option
 */
export function backgrondCategoryApi(option) {
    return axios.get(`${PATH}picture-category`, { params: option, loading: true });
}

/**
 * 获取素材列表
 * @param {*} option
 */
export function backgrondListsApi(option) {
    return axios.get(`${PATH}material`, { params: option });
}

/**
 * 根据素材id获取对应样式
 * @param {*} option
 */
export function coverStyleApi(id) {
    return axios.get(`${PATH}material/${id}`);
}

/**
 * 随机图片接口
 * @param {*} option
 */
export function coverRandomApi(option) {
    return axios.get(`${PATH}material/random`, { params: option });
}
